import { transparentColors } from "../../assets/styles/helpers/colors.styles";

export const drawerStyles = {
  zIndex: 1,
  top: "auto",
  ".MuiModal-backdrop": {
    background: transparentColors.blackShade4,
    backdropFilter: "blur(3px)",
  },
  ".MuiPaper-root": {
    maxWidth: "480px",
    margin: "0 auto",
    background: transparentColors.blackShade6,
    backdropFilter: "blur(4px)",
    // MUI's bottom-anchored paper is height:auto, so it stops wherever the
    // content ends — leaving a strip of the page uncovered at the top and
    // never overflowing, which means overflow-y:auto never scrolls. Pin it to
    // the visible viewport so it always covers the screen and scrolls once the
    // content exceeds it.
    height: "100dvh",
    maxHeight: "100dvh",
    overflowY: "auto",
  },
};
